export { ProviderDetailsWidget } from './ProviderDetailsWidget';
